import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import ErrorPage from 'yoda-site-components/lib/components/ErrorPage/ErrorPage';

export default class ErrorFullPage extends PureComponent {
    static propTypes = {
        customErrorPageComponent: PropTypes.element,
        templateType: PropTypes.string,
    };

    static defaultProps = {
        customErrorPageComponent: null,
        templateType: '500',
    };

    render() {
        const { customErrorPageComponent, templateType } = this.props;
        return (
            <Layout>{customErrorPageComponent || <ErrorPage templateType={templateType} />}</Layout>
        );
    }
}
